import { useNavigate } from "react-router-dom";

import { useTranslation } from "@/core/i18n";
import { DidYouKnowScreen } from "../components/DidYouKnowScreen";
import { usePersonalisationData } from "../context/PersonalisationDataContext";

import { SkinSunContainer_PATH } from "./SkinSunContainer";

export const SkinColorFeedbackContainer_PATH = "/personalise/skin-color-feedback" as const;

export const SkinColorFeedbackContainer = () => {
  const navigate = useNavigate();
  const { advisorIdentity } = usePersonalisationData();
  const { t } = useTranslation();

  return (
    <DidYouKnowScreen
      content={t("skinColorFeedbackContainer.content")}
      adonisIdentity={advisorIdentity}
      onNext={() => navigate(SkinSunContainer_PATH)}
    />
  );
};
